import {useTransition} from '@yandex-delivery/blocks'
import type {ServerError} from '@yandex-delivery/core/utils/network'
import {useCallback} from 'react'

import {fetchOrderAvailability} from '../api'
import {appConfig} from '../config'
import type {OrderAvailabilityError} from '../types'

export function useOrderAvailability() {
  const [{isPending, payload, error}, startTransition] = useTransition<{}, ServerError<OrderAvailabilityError>>(
    undefined,
    {
      key: 'order-availability',
    },
  )

  const startOrderAvailabilityTransition = useCallback(() => {
    startTransition(() => {
      return fetchOrderAvailability(appConfig.countryCode)
    })
  }, [])

  return {
    error,
    startOrderAvailabilityTransition,
    isOrderAvailabilityPending: isPending,
    orderAvailability: payload,
  }
}
